<template>
  <el-dialog
    left
    title="Add LP Document"
    width="455px"
    :closeOnClickModal="false"
    :closeOnPressEscape="false"
    :showClose="true"
    :visible.sync="isShow"
    @close="handleCancelAddDocument"
    class="addDocumentsCard"
  >
    <div class="row">
      <div class="col-6">
        <div>
          LP Entity
          <span class="required">*</span>
        </div>
        <el-select
          class="todo-dropdown-el-select"
          size="large"
          required
          placeholder="Select Lp Entity"
          v-model="value.data.lp_item"
          @change="changeLpEntity(value.data.lp_item)"
        >
          <el-option
            v-for="item in lpDetailsData"
            :key="item._id"
            :label="item.entity_name"
            :value="item._id"
          ></el-option>
        </el-select>
      </div>
      <div class="col-6">
        <div>Date</div>
        <!-- v-model="value.data.date" -->
        <input
          class="todo-form-date todo-form form-control"
          type="date"
          :value="value.data.date && moment.utc(value.data.date).format('YYYY-MM-DD')?moment.utc(value.data.date).format('YYYY-MM-DD'):moment.utc(new Date()).format('YYYY-MM-DD')"
          @input="value.data.date = moment($event.target.valueAsDate)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div>Notes</div>
        <textarea
          placeholder="Notes"
          required="required"
          rows="4"
          cols="50"
          class="form-control"
          v-model="value.data.notes"
        ></textarea>
      </div>
    </div>
    <div class="row ml-0 mr-0" style="margin-top:10px">
      <div
        class="col-4 pl-0 pr-0"
        id="popover-target-1"
        style="/*padding-top: 6px;padding-left:0px;padding-right:0px*/"
      >
        <div class="attach-class d-flex justify-content-center align-items-center">
          <div>
            <i class="fa fa-paperclip" aria-hidden="true"></i>
          </div>
          <div>Attach a file</div>
          <input type="file" ref="fileBtn" if="fileId" @change="handleFile" class="hidden" />
        </div>
      </div>
      <b-popover
        target="popover-target-1"
        triggers="hover"
        placement="top"
        custom-class="popover-modal-class"
      >
        <div
          class="m-2"
          style="cursor:pointer"
          @click="$refs.fileBtn.click();typeUrlCheck =false"
        >From Computer</div>
        <div class="m-2" style="cursor:pointer" @click="typeUrlCheck =!typeUrlCheck">Add Link</div>
      </b-popover>
      <div
        class="col-8 pl-0 pr-0"
        style="/*padding-top: 6px;*/"
        v-if="!typeUrlCheck"
        v-cloak
        @drop.prevent="addFile"
        @dragover.prevent
      >
        <div
          class="drag-drop-class d-flex justify-content-center align-items-center"
          style="height:36px"
        >Drag and drop file to attach</div>
      </div>
      <div class="col-8" style="padding:0" v-else>
        <form @submit.prevent="submitUrl">
          <input
            type="text"
            class="form-control team-form url-input-form"
            placeholder="Add a URL"
            id="myInput"
            @blur="submitUrl"
            v-model="urlValue"
            @
          />
        </form>
      </div>
    </div>
    <div class="mt-3">
      <div class="row ml-0 mr-0" v-if="url.add.length || url.update.length ||files.add.length">
        <div class="col-6 pl-0 pr-0">
          <div>Document Name</div>
        </div>
        <div class="col-6 pl-0 pr-0">
          <div style="padding-left: 5px;">
            Document Type
            <span class="required">*</span>
          </div>
        </div>
      </div>
      <div v-if="url.add">
        <div
          v-for="(item,index) in url.add"
          :key="index"
          class="d-flex align-items-center fileItem my-2"
          style="padding-top:0px;height:45px"
        >
          <div class="col-6 pl-0 pr-0">
            <div class="d-flex">
              <a :href="formatUrl(item)" target="_blank">
                <span style="width: 300px;" class="attachment-name-class">{{item}}</span>
              </a>
            </div>
          </div>
          <div class="col-6 pl-0 pr-0">
            <div class="d-flex">
              <div class="col-10 pl-0 pr-0">
                <el-select
                  class="todo-dropdown-el-select documents-dropdown-el-select"
                  size="small"
                  required
                  placeholder="Select Document type"
                  v-model="documentTypeUrlAdd[index]"
                  @change="DocumentTypeChange(documentTypeUrlAdd[index],'url','add')"
                >
                  <el-option
                    v-for="item in vals.LP_DOCUMENT_TYPE_OPTIONS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-2">
                <div style="margin-top: 5px;">
                  <i class="fas fa-times" @click="deleteURL(index,'add')" style="cursor:pointer"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="url.update">
        <div
          v-for="(item,index) in url.update"
          :key="index"
          class="d-flex align-items-center fileItem my-2"
          style="padding-top:0px;height:45px"
        >
          <div class="col-6 pl-0 pr-0">
            <div class="d-flex">
              <a :href="formatUrl(item.url)" target="_blank">
                <span style="width: 300px;" class="attachment-name-class">{{item.url}}</span>
              </a>
            </div>
          </div>
          <div class="col-6 pl-0 pr-0">
            <div class="d-flex">
              <div class="col-10 pl-0 pr-0">
                <el-select
                  class="todo-dropdown-el-select documents-dropdown-el-select"
                  size="small"
                  required
                  placeholder="Select Document type"
                  v-model="documentTypeUrlEdit[index]"
                  @change="DocumentTypeChange(documentTypeUrlEdit[index],'url','edit')"
                >
                  <el-option
                    v-for="item in vals.LP_DOCUMENT_TYPE_OPTIONS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-2">
                <div style="margin-top: 5px;">
                  <i class="fas fa-times" @click="deleteURL(index,'update')" style="cursor:pointer"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="files.add">
        <div
          v-for="(item,index) in files.add"
          :key="index"
          class="d-flex align-items-center fileItem my-2"
          style="padding-top:0px;height:45px"
        >
          <div class="col-6 pl-0 pr-0">
            <div class="d-flex justify-content-center align-items-center">
              <i
                v-if="item.type.includes('.doc') || item.name.includes('.doc') || item.name.includes('.txt')"
                class="fas fa-file-word mr-2"
                style="color:#5190FF;/*padding-top:3px;*/"
              ></i>
              <i
                v-else-if="item.type.includes('zip') || item.name.includes('.zip') || item.type.includes('rar') || item.name.includes('.rar')"
                class="far fa-file-archive mr-2"
                style="/*padding-top:3px;*/"
              ></i>
              <i v-else-if="item.type.includes('image')" class="fas fa-image mr-2"></i>
              <i
                v-else-if="item.type.includes('csv') || item.type.includes('xls') || item.name.includes('.csv') || item.name.includes('.xls')"
                class="fas fa-file-excel mr-2"
                style="color:#F15643;/*padding-top:3px;*/"
              ></i>
              <i
                v-else-if="item.type.includes('pdf') || item.type.includes('.pdf')"
                class="fas fa-file-pdf mr-2"
                style="color:#F15643;/*padding-top:3px;*/"
              ></i>
              <!-- @click="handleDownload(item,'file')" -->
              <span
                style="cursor:pointer;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;flex-grow: 1;"
              >{{item.name}}</span>
            </div>
          </div>
          <div class="col-6 pl-0 pr-0">
            <div class="d-flex justify-content-center align-items-center">
              <div class="col-10 pl-0 pr-0">
                <el-select
                  class="todo-dropdown-el-select documents-dropdown-el-select"
                  size="small"
                  required
                  placeholder="Select Document type"
                  v-model="files.documentType[index]"
                  @change="DocumentTypeChange(files.documentType[index],'files','add')"
                >
                  <el-option
                    v-for="item in vals.LP_DOCUMENT_TYPE_OPTIONS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-2 pl-0 pr-0">
                <div
                  style="/*margin-top: 5px;*/cursor:pointer;padding-right: 10px;padding-left: 10px;"
                >
                  <i class="fas fa-times" @click="deleteFile(index,'add')"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex" style="padding: 0px;">
      <div class="col-xl edit-company-action-button-row" style="padding:0px;">
        <button
          type="button"
          class="todo-form-cancel-button btn-outline-secondary"
          @click.prevent="handleCancelAddDocument"
        >Cancel</button>
        <button
          type="submit"
          @click.prevent="saveFiles"
          class="todo-form-submit-button btn btn-primary"
          style="height:35px;"
          :disabled="showSpinner || saveDisable"
        >
          Save
          <b-spinner v-if="showSpinner" style="float: right;" small label="Loading..."></b-spinner>
        </button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { Dialog } from "element-ui";
import moment from "moment";
import { Select, Option } from "element-ui";
import api from "../../../axios_api";
import { mapGetters } from "vuex";
import { vals } from "../../../util";
export default {
  name: "addLpDocuments",
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    value: {
      isShow: Boolean,
      isCreate: Boolean,
      data: Object,
    },
    lpItem: Object,
  },
  computed: {
    ...mapGetters("lpAllocations", ["lpDetailsData"]),
    isShow: {
      get() {
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
        this.$emit("input", this.value);
      },
    },
    isCreate: {
      get() {
        return this.value.isCreate;
      },
      set(value) {
        this.value.isCreate = value;
      },
    },
    moment() {
      return moment;
    },
  },
  data() {
    return {
      showSpinner: false,
      files: {
        add: [],
        update: [],
        delete: [],
        documentType: [],
      },
      url: {
        add: [],
        update: [],
        delete: [],
      },
      typeUrlCheck: false,
      urlValue: "",
      downloadLink: "",
      vals,
      documentTypeUrlAdd: [],
      documentTypeUrlEdit: [],
      selectedlpEntity: {},
      saveDisable: true,
    };
  },
  methods: {
    changeLpEntity(lpItem) {
      if (lpItem) {
        this.selectedlpEntity = this.lpDetailsData.find((item) => {
          if (item._id == lpItem) {
            return item;
          }
        });
      }
      this.checkValidations();
    },
    handleCancelAddDocument() {
      this.files = {
        add: [],
        update: [],
        delete: [],
        documentType: [],
      };
      this.url = {
        add: [],
        update: [],
        delete: [],
      };
      this.urlValue = "";
      this.typeUrlCheck = false;
      this.showSpinner = false;
      this.documentTypeUrlAdd = [];
      this.documentTypeUrlEdit = [];
      this.selectedlpEntity = {};
      this.saveDisable = true;
      this.value.data = {};
      this.isShow = false;
    },
    checkValidations() {
      if (this.value.data.lp_item && this.value.data.lp_item.length > 0) {
        if (this.files.add.length == this.files.documentType.length) {
          if (this.files.add.length > 0) {
            this.saveDisable = false;
          } else {
            if (this.url.add.length == 0) {
              this.saveDisable = true;
            } else {
              if (this.url.add.length == this.documentTypeUrlAdd.length) {
                this.saveDisable = false;
              } else {
                this.saveDisable = true;
              }
            }
          }
        } else {
          if (this.files.add.length > 0) {
            this.saveDisable = true;
          }
        }
        if (this.url.add.length == this.documentTypeUrlAdd.length) {
          if (this.url.add.length > 0) {
            this.saveDisable =
              this.files.add.length == this.files.documentType.length
                ? false
                : true;
          } else {
            if (this.files.add.length == 0) {
              this.saveDisable = true;
            } else {
              if (this.files.add.length == this.files.documentType.length) {
                this.saveDisable = false;
              } else {
                this.saveDisable = true;
              }
            }
          }
        } else {
          if (this.url.add.length > 0) {
            this.saveDisable = true;
          }
        }
      } else {
        this.saveDisable = true;
      }
    },
    DocumentTypeChange(selected, context, operation) {
      this.checkValidations();
    },
    submitUrl() {
      this.urlValue = this.urlValue.trim();
      if (this.urlValue.length > 0) {
        this.url.add.push(this.urlValue);
        this.urlValue = "";
      }
      this.typeUrlCheck = false;
      this.checkValidations();
    },
    deleteFile(index, type) {
      if (type == "add") {
        this.files.add.splice(index, 1);
        this.files.documentType.splice(index, 1);
      } else {
        let data = this.files.update.splice(index, 1);
        this.files.delete.push(data[0]);
      }
      this.checkValidations();
    },
    deleteURL(index, type) {
      if (type == "add") {
        this.url.add.splice(index, 1);
        this.documentTypeUrlAdd.splice(index, 1);
      } else {
        let data = this.url.update.splice(index, 1);
        this.url.delete.push(data[0]);
      }
      this.checkValidations();
    },
    formatUrl(url) {
      // make sure it starts w/ http(s)
      if (url.length > 1) {
        if (!url.startsWith("https")) url = "https://" + url;
        return url;
      } else return "";
    },
    handleFile(e) {
      let droppedFiles = e.target.files;
      if (!droppedFiles) return;
      [...droppedFiles].forEach((f) => {
        this.files.add.push(f);
      });
      this.checkValidations();
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      [...droppedFiles].forEach((f) => {
        this.files.add.push(f);
      });
      this.checkValidations();
    },
    saveFiles() {
      this.showSpinner = true;
      let self = this;
      let filePayload = {
        files: [],
        data: [],
        notificationFiles: [],
      };
      if (this.urlValue) {
        this.url.add.push(this.urlValue);
        this.urlValue = "";
      }
      this.files.add.map((item, index) => {
        if (item && item.isStored && item.s3_path) {
          filePayload.files.push(null);
          filePayload.data.push({
            _id: item._id,
            name: item.name,
            collection_name: "lp",
            document_id: this.selectedlpEntity._id,
            lp_item: this.selectedlpEntity,
            link_type: "File",
            isStored: item.isStored,
            s3_path: item.s3_path,
            date: this.value.data.date ? this.value.data.date : new Date(),
            notes: this.value.data.notes ? this.value.data.notes : "",
            document_type: this.files.documentType[index]
              ? this.files.documentType[index]
              : "",
            entity_type: "LP",
          });
        } else {
          filePayload.files.push(item);
          filePayload.data.push({
            _id: item._id,
            name: item.name,
            collection_name: "lp",
            document_id: this.selectedlpEntity._id,
            lp_item: this.selectedlpEntity,
            link_type: "File",
            date: this.value.data.date ? this.value.data.date : new Date(),
            notes: this.value.data.notes ? this.value.data.notes : "",
            document_type: this.files.documentType[index]
              ? this.files.documentType[index]
              : "",
            entity_type: "LP",
          });
        }
      });
      self.url.add.map((item, index) => {
        if (item) {
          filePayload.files.push(null);
          filePayload.data.push({
            _id: item._id,
            name: item.name,
            collection_name: "lp",
            document_id: this.selectedlpEntity._id,
            lp_item: this.selectedlpEntity,
            link_type: "URL",
            url: item,
            date: this.value.data.date ? this.value.data.date : new Date(),
            notes: this.value.data.notes ? this.value.data.notes : "",
            document_type: this.documentTypeUrlAdd[index]
              ? this.documentTypeUrlAdd[index]
              : "",
            entity_type: "LP",
          });
        }
      });
      self.$store.dispatch("lpAllocations/apiPostLpDocument", filePayload).then(
        (item) => {
          self.handleCancelAddDocument();
          if (
            item.data.encrypt.limitExceededMessage &&
            item.data.encrypt.limitExceededMessage.length > 0 &&
            item.data.encrypt.limitExceededMessage == "Storage Limit Exceeded"
          ) {
            self.$toaster.error(
              "Storage limit exceeded. Upgrade your plan to add more"
            );
          } else {
            self.$toaster.success("Saved Successfully");
          }
          self.$emit("refresh", item);
        },
        (error) => {
          this.showSpinner = false;
          self.$toaster.error("Failed to add document");
        }
      );
    },
  },
  mounted() {},
};
</script>